import React, { useCallback, useContext, useEffect, useState } from 'react'
import './Roles.css'
import { GlobalAgGridTable } from '../Deal/AgGridReactComponent/GlobalAgGridTable';
import AwsServerService from '../../common/util/AwsServerService';
import AppContext from '../../Context/AppContext';
import UserService from '../../common/util/UserService';
import swal from "sweetalert";
import { Button, Input, message, Modal, Select } from 'antd';
import { refershModule, Socket } from '../../Context/AppActions';
import { Col, Label, Row } from 'reactstrap';
import TextArea from 'antd/es/input/TextArea';
import { useDispatch, useSelector } from 'react-redux';
import { NewUserPicker } from '../../common/UserPicker/NewUserPicker';
import { NewCustomePopover } from '../TaskBluePrints/HelperComponents/NewCustomePopover';
import { RoleUserPicker } from './RoleUserPicker';
import RolesPopupData from './RolesPopupData';
import { setRefershModule } from '../../Context/ReduxContext';
import { canAccess, canView } from '../../common/util/appUtils';

const Roles = ({ history, location }) => {
  const [Errorarray,setErrorarray]=useState({});
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const AppData = useContext(AppContext);
  const { dispatch, state } = AppData || {};
  const AppReduxContext = useSelector((state) => state.AppReduxContext); // Read state
  const RefershModule = useSelector((state) => state.AppReduxContext.refershModule);
  const ModuleTab = useSelector((state) => state.AppReduxContext.ModuleTab);
  const dispatchRedux = useDispatch(); // Dispatch actions

  const [view, setView] = useState();
  // const [allProjects, setAllProjects] = useState([]);
  const defaulRoleState = { open: false, module: "", data: null, type: "create" }
  const [projectRoleObject, setprojectRoleObject] = useState({
      "RoleId": "",
      "UserId":"",
      "UserType":"",
    })
  const [openRoleModal, setOpenRoleMadal] = useState({ open: false, module: "", data: {
    RoleType: view,
  }, type: "create" });
  // const [refresh, setRefresh] = useState(false);

  const [allRoles, setAllRoles] = useState([])
  const [allCacheRoles, setAllCacheRoles] = useState([])
  // const [allUserRoles, setAllUserRoles] = useState([])
  // const [allCacheUserRoles, setAllCacheUserRoles] = useState([])

  const [allUsers, setAllUsers] = useState([]);
  const [errorPopConfirm, setErrorPopConfirm] = useState();

  //   const [allUserRoles,setAllUserROles]=useState([]);

  useEffect(() => {
    UserService.GetAllUsers().then(r => {
      setAllUsers(r.data.users)
    })
  }, [])
  useEffect(e => {
    if (ModuleTab && ModuleTab.tab) {
      setView(ModuleTab.tab);
    }
  }, [AppReduxContext])
  // useEffect(e => {
  //   if (state.AllDeals) {
  //     setAllProjects(state.AllDeals);
  //   }
  // }, [state.AllDeals])

  const actionListCellRenderer = (params) => {
    const canEdit = canAccess(accessContext, "Roles", "Edit")
    const canDelete = canAccess(accessContext, "Roles", "Delete")
    // console.log(params);
    let btnDiv = document.createElement("div");
    btnDiv.classList.add("global-action-btn-for-tables");

    let editBtn = document.createElement('button');
    editBtn.classList.add("add")
    editBtn.innerText = "Edit"
    editBtn.id = params.ROWID;
    editBtn.addEventListener('click', (e) => {
      if(!canEdit){
        message.error("Permission Denied");
        return;
      }
      let Rowid = e.currentTarget.id;
      
      if (params.ROWID == Rowid) {
        // if (params && view !== "roles") {
        //   // params = { ...params, RoleId: "Roles_" + params.RoleId};
        //   setprojectRoleObject(params);
        // }
        setOpenRoleMadal({ open: true, data: {...params}, module:"roles", type: "edit" });
      }
    })
    let deleteBtn = document.createElement('button');
    deleteBtn.classList.add("add")
    deleteBtn.style.color = "red";
    deleteBtn.innerText = "Delete";
    deleteBtn.id = params.ROWID;
    deleteBtn.addEventListener('click', (e) => {
      if(!canDelete){
        message.error("Permission Denied");
        return;
      }
      let Rowid = e.currentTarget.id;
      swal({
        title: "Warning!",
        text: `Are you sure you want to delete the ${view == "roles" ? "Role" : "User Role"}?`,
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          confirm: "Proceed",
        },
      }).then(async (isDelete) => {
        if (isDelete) {
          AwsServerService.CrudServiceHandler({ method: "DELETE", data: {ROWID : Rowid}, route:"ROLES" }).then(res => {
            dispatch(Socket({ trigger: "Refresh_Module", data: "Roles"}))
          })
        }
      })
    })
    btnDiv.appendChild(editBtn);
    btnDiv.appendChild(deleteBtn);
    return btnDiv;
  }


  const columnForZoho = [
    {
      field: "RoleName",
      name: "Role Name",
      path: "RoleName",
      //   key: "Action",
      type: "text",
      label: "Role Name",
      cellStyle: { textAlign: "left" } ,
      id: 0,
      isChecked: false,
      isDragOver: false,
      isSearch: true,
      content: (obj) => (
        <label
        // hidden={selectedTbl === "dayView"} 
        >
          {obj.RoleName}
        </label>
      ),
    },
    {
      field: "Description",
      name: "Description",
      path: "Description",
      type: "text",
      label: "Description",
      cellStyle: { textAlign: "left" } ,
      id: 1,
      isChecked: false,
      isDragOver: false,
      isSearch: true,
      content: (obj) => (
        <label
        // hidden={selectedTbl === "dayView"} 
        >
          {obj.Description}
        </label>
      ),
    },
    {
      field: "Action",
      key: "Action",
      name: "Action",
      path: "Action",
      type: "text",
      label: "Action",
      id: 2,
      isChecked: false,
      isDragOver: false,
      isSearch: true,
      content: actionListCellRenderer,
    },
  ];
  // const userRoleCols = [
  //   {
  //     field: "ProjectId",
  //     name: "Project/Deal",
  //     path: "ProjectId",
  //     type: "text",
  //     // key: "UserId",
  //     label: "UserId",
  //     id: 0,
  //     isChecked: false,
  //     isDragOver: false,
  //     isSearch: true,
  //   },
  //   {
  //     field: "UserId",
  //     name: "User",
  //     path: "UserId",
  //     type: "text",
  //     key: "UserId",
  //     label: "UserId",
  //     id: 1,
  //     isChecked: false,
  //     isDragOver: false,
  //     isSearch: true,
  //     content: (obj) => {
  //        
  //       if(obj.UserType == "Zoho Users"){
  //         return allUsers.find(k => k.zuid == obj.UserId)?.full_name;
  //       }else{
  //         return AppReduxContext?.AllModuleUsers[obj.UserType]?.find(k => k.value == obj.UserId)?.label;
  //       }
  //     },
  //   },
  //   {
  //     field: "UserType",
  //     name: "User Type",
  //     path: "UserType",
  //     type: "text",
  //     // key: "UserId",
  //     label: "UserId",
  //     id: 2,
  //     isChecked: false,
  //     isDragOver: false,
  //     isSearch: true,
  //     // content: (obj) => {
  //     //    
  //     //   let name = allUsers.find(k => k.zuid == obj.UserId)?.full_name;
  //     //    
  //     //   return name;
  //     // },
  //   },
  //   {
  //     field: "RoleId",
  //     name: "Role Name",
  //     path: "RoleId",
  //     key: "RoleId",
  //     type: "text",
  //     label: "Role Name",
  //     id: 3,
  //     isChecked: false,
  //     isDragOver: false,
  //     isSearch: true,
  //     content: (obj) => {
  //       let name = allCacheRoles.find(k => k.ROWID == obj.RoleId)?.RoleName;
  //       return name;
  //     },
  //   },
  //   {
  //     field: "Action",
  //     key: "Action",
  //     name: "Action",
  //     path: "Action",
  //     type: "text",
  //     label: "Action",
  //     id: 4,
  //     isChecked: false,
  //     isDragOver: false,
  //     isSearch: true,
  //     content: actionListCellRenderer,
  //   },
  // ];
  const fetRoles = () => {
    AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "ROLES" }).then(res => {
      setAllRoles(res.data);
      setAllCacheRoles(res.data);
    }).catch(err => {
      console.log(err);
    })
  }
  // const fetUserRoles = () => {
  //   AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "USERROLES" }).then(res => {
  //     setAllUserRoles(res.data);
  //     setAllCacheUserRoles(res.data);
  //   }).catch(err => {
  //     console.log(err);
  //   })
  // }
  useEffect(e => {
    if (RefershModule?.module == "Roles") {
      fetRoles();
      dispatchRedux(setRefershModule(null))
    }
    // if (state.refershModule?.module == "UserRoles") {
    //   fetUserRoles();
    //   dispatch(refershModule(null))
    // }
  }, [RefershModule])
  useEffect(() => {
    fetRoles();
    // fetUserRoles();
  }, [])
  const extraComponentToRight = (e) => {
    return (
      <div className="extra-component-request-toRight">
        <div className="job-action-box">
          <Button
            style={canAccess(accessContext, "Roles", "Create") ? {} : {opacity: 0.2, pointerEvents: "none", cursor: "not-alloweds"}}
            type='primary'
            className="mr-3 request-btns"
            onClick={() => {
              setOpenRoleMadal({ module: "roles", data: {
                RoleType: view,
              }, open: true, type: "create" });
            }}
          >
            Add Role
          </Button>
        </div>
      </div>
    );
  }
  const onSaveRole = (data, module) => {
    let checkDuplicateEntry;
    if (data) {
      let payload = {};
      if (module == "userrole") {
        payload = {
          RoleId: data.RoleId.split("_")[1],
          UserId: data.UserId.split("_")[1],
          UserType: data.UserId.split("_")[0],
          ProjectId: data.ProjectId,
        }
      } else {
        checkDuplicateEntry = allCacheRoles.find(e => e.RoleName == data.RoleName);
        payload = {
          RoleName: data.RoleName,
          RoleType: data.RoleType,
          Description: data.Description,
        }
      }
      let Error=false;
      let Errorarray1={

      }
      Object.keys(payload).map((item)=>{
        if(payload[item]=="" || payload[item]==undefined){
          Error=true
          Errorarray1[item]=true;
        }
      })
      setErrorarray(Errorarray1)
      if(Error){
        return false;
      }
      if (data.ROWID) {
        payload["ROWID"] = data.ROWID;
        AwsServerService.CrudServiceHandler({ method: "PUT", data: payload, route: "ROLES" }).then(res => {
          dispatch(Socket({ trigger: "Refresh_Module", data: "Roles"}))
          onCloseRoleModal();
        }).catch(e => {
        })
      } else {
        if (module != "userrole" && checkDuplicateEntry) {
          setErrorPopConfirm("Role Name already exists!")
          return
        }
        AwsServerService.CrudServiceHandler({ method: "POST", data: payload, route: "ROLES" }).then(res => {
          dispatch(Socket({ trigger: "Refresh_Module", data: "Roles"}))
          onCloseRoleModal();
        }).catch(e => {
        })
      }
    }else{
      setErrorarray({
        RoleName:true,
        RoleType:true,
        Description:true,
      })
    }
  }
  const onCloseRoleModal = (data) => {
    setOpenRoleMadal(defaulRoleState);
  }
  const onChangeField = ({ value, field, data, setDataFunction, isSetKey }) => {
     setErrorarray([])
    if (isSetKey) {
      data[isSetKey] = data[isSetKey] || {};
      if (field) {
        data[isSetKey][field] = value;
      }
    } else {
      if (field) {
        data[field] = value;
      }
    }
    setDataFunction && setDataFunction(data);
  }
  useEffect(()=>{console.log("Errorarray",Errorarray);
  },[Errorarray])
  const roleModal = useCallback(() => {
    return <>
      <Modal
        destroyOnClose={true}
        rootClassName='Role-Modal'
        className='Role-Modal'
        title={openRoleModal?.type == "edit" ? "Edit Role" : "Create Role"}
        onCancel={onCloseRoleModal}
        open={openRoleModal?.module == "roles" && openRoleModal?.open}
      >
        <div className='Role-Modal-Body Custom-Input-Wrapper'>
          <Row className="Input-Group mb-3">
            <Col>
              <span className="labeltext">
                Role Name
              </span>
              <Input
                // disabled={bluePrintData?.lock == "true"}
                className="input"
                status={Errorarray?.RoleName?'error':''}
                value={openRoleModal?.data?.RoleName}
                onChange={(e) => {
                  e.currentTarget.value = (e.currentTarget.value)?.trimStart();
                  onChangeField({
                    value: e.currentTarget.value,
                    field: "RoleName",
                    data: { ...openRoleModal },
                    setDataFunction: (d) => setOpenRoleMadal(d),
                    isSetKey: "data"
                  })
                }}
              />
              {/* {error.includes("name") && (
                                <span style={{ color: "red" }}>
                                    Please fill the required field
                                </span>
                            )} */}
            </Col>
          </Row>
          <Row className="Input-Group mb-3">
            <Col>
              <span className="labeltext">
                Role Type
              </span>
              <Select
                // disabled={bluePrintData?.lock == "true"}
                // className="input"
                status={Errorarray?.RoleType ?'error':''}
                style={{width:"100%",height:"100%"}}
                value={openRoleModal?.data?.RoleType}
                onChange={(val) => {
                  // e.currentTarget.value = (e.currentTarget.value)?.trimStart();
                  onChangeField({
                    value: val,
                    field: "RoleType",
                    data: { ...openRoleModal },
                    setDataFunction: (d) => setOpenRoleMadal(d),
                    isSetKey: "data"
                  })
                }}
              >
                <Select.Option value={"Zoho"}>Internal</Select.Option>
                <Select.Option value={"Account"}>Account</Select.Option>
                <Select.Option value={"Deal"}>Deal</Select.Option>
                <Select.Option value={"Vendor"}>Vendor</Select.Option>
                <Select.Option value={"Other"}>Other Contacts Role</Select.Option>
                
              </Select>
              {/* {error.includes("name") && (
                                <span style={{ color: "red" }}>
                                    Please fill the required field
                                </span>
                            )} */}
            </Col>
          </Row>
          <Row className="Input-Group  mb-3">
            <Col>
              <span className="labeltext">
                Description
              </span>
              <TextArea
                // disabled={bluePrintData?.lock == "true"}
                status={Errorarray?.Description ?'error':""}
                value={openRoleModal?.data?.Description}
                style={{
                  padding: "5px 13px",
                  "min-height": "5rem",
                  "max-height": "5rem",
                }}
                onChange={(e) => {
                  e.currentTarget.value = (e.currentTarget.value)?.trimStart();
                  onChangeField({
                    value: e.currentTarget.value,
                    field: "Description",
                    data: { ...openRoleModal },
                    setDataFunction: (d) => setOpenRoleMadal(d),
                    isSetKey: "data"
                  })
                }}
              />
              {/* {error.includes("name") && (
                                <span style={{ color: "red" }}>
                                    Please fill the required field
                                </span>
                            )} */}
            </Col>
          </Row>
          <Row className='Button-Group-Class'>
            <Button style={{ width: "auto", padding: "7px" }}
              onClick={()=>{
                setOpenRoleMadal((prev) => ({ ...prev, data:{...prev.data,Description:"",RoleName:""} }));
              }}
            >Clear</Button>
            <Button style={{ width: "auto", padding: "7px" }} type='primary'
              onClick={() => onSaveRole(openRoleModal.data)}
            >{openRoleModal.type == "edit" ? "Update" : "Save"}</Button>
          </Row>
        </div>
      </Modal>
    </>
  },[openRoleModal,Errorarray])
  // const userRoleModal = () => {
  //   return <>
  //     <Modal
  //       className='Role-Modal'
  //       destroyOnClose={true}
  //       title={openRoleModal?.type == "edit" ? "Edit User Role" : "Create User Role"}
  //       onCancel={onCloseRoleModal}
  //       open={openRoleModal?.module == "userroles" && openRoleModal?.open}
  //     >
  //       <div className='Role-Modal-Body Custom-Input-Wrapper'>
  //         <Row className="Input-Group mb-3">
  //           <Col>
  //             <span className="labeltext">
  //               Select User
  //             </span>
  //             <RoleUserPicker key={2}
  //               placeholder={"Select Role"}
  //               onChange={val => onChangeField({
  //                 value: val,
  //                 field: "UserId",
  //                 data: { ...openRoleModal },
  //                 setDataFunction: (d) => setOpenRoleMadal(d),
  //                 isSetKey: "data"
  //               })}
  //               groupFromProps={["Accounts", "Zoho Users"]}
  //               value={openRoleModal?.data?.UserId}
  //             />

  //             {/* {error.includes("name") && (
  //                               <span style={{ color: "red" }}>
  //                                   Please fill the required field
  //                               </span>
  //                           )} */}
  //           </Col>
  //         </Row>
  //         <Row className="Input-Group mb-3">
  //           <Col>
  //             <span className="labeltext">
  //               Select Role
  //             </span>
  //             <RoleUserPicker key={2}
  //               placeholder={"Select Role"}
  //               groupFromProps={["Roles"]}
  //               value={openRoleModal?.data?.RoleId}
  //               onChange={val => onChangeField({
  //                 value: val,
  //                 field: "RoleId",
  //                 data: { ...openRoleModal },
  //                 setDataFunction: (d) => setOpenRoleMadal(d),
  //                 isSetKey: "data"
  //               })}
  //             />
  //             {/* {error.includes("name") && (
  //                               <span style={{ color: "red" }}>
  //                                   Please fill the required field
  //                               </span>
  //                           )} */}
  //           </Col>
  //         </Row>
  //         <Row className="Input-Group mb-3">
  //           <Col>
  //             <span className="labeltext">
  //               Select Deal
  //             </span>
  //             <Select
  //               value={openRoleModal?.data?.ProjectId}
  //               style={{ width: "100%", height: "auto" }}
  //               onChange={e => {
  //                  
  //                 onChangeField({
  //                   value: e,
  //                   field: "ProjectId",
  //                   data: { ...openRoleModal },
  //                   setDataFunction: (d) => setOpenRoleMadal(d),
  //                   isSetKey: "data"
  //                 })
  //               }}>
  //               {state?.AllDeals?.map((deal, i) => {
  //                 return <Select.Option
  //                   key={deal.Deal_Name}
  //                   value={deal.Deal_Name}
  //                   label={deal.Deal_Name}
  //                   children={deal.Deal_Name}
  //                   icon={<></>} />
  //               })}
  //             </Select>
  //             {/* {error.includes("name") && (
  //                               <span style={{ color: "red" }}>
  //                                   Please fill the required field
  //                               </span>
  //                           )} */}
  //           </Col>
  //         </Row>
  //         <Row className='Button-Group-Class'>
  //           <Button style={{ width: "auto", padding: "7px" }}
  //             onClick={onCloseRoleModal}
  //           >Clear</Button>
  //           <Button style={{ width: "auto", padding: "7px" }} type='primary'
  //             onClick={() => onSaveRole(openRoleModal.data, "userrole")}
  //           >{openRoleModal.type == "edit" ? "Update" : "Save"}</Button>
  //         </Row>
  //       </div>
  //     </Modal>
  //   </>
  // }

  const getTableData = useCallback(() => {
    return <>
      {view == "Zoho" ?
        <GlobalAgGridTable
          headers={columnForZoho}
          setRowData={setAllRoles}
          cacheRowData={allCacheRoles}
          setCacheRowData={setAllCacheRoles}
          module="Roles"
          mainUrl="role"
          // DropDownFields={["User Name", "Check In", "Check Out"]}
          rowData={allRoles?.filter(r => r.RoleType == "Zoho")}
          renderExtraComponent={() => <></>}
          renderExtraComponentToRight={extraComponentToRight}
          isTaskFilterHide={true}
        /> : view == "Account" ?
          <GlobalAgGridTable
            headers={columnForZoho}
            setRowData={setAllRoles}
            cacheRowData={allCacheRoles}
            setCacheRowData={setAllCacheRoles}
            module="Roles"
            mainUrl="role"
            // DropDownFields={["User Name", "Check In", "Check Out"]}
            rowData={allRoles?.filter(r => r.RoleType == "Account")}
            renderExtraComponent={() => <></>}
            renderExtraComponentToRight={extraComponentToRight}
            isTaskFilterHide={true}
          /> : view == "Deal" ?
            <GlobalAgGridTable
              headers={columnForZoho}
              setRowData={setAllRoles}
              cacheRowData={allCacheRoles}
              setCacheRowData={setAllCacheRoles}
              module="Roles"
              mainUrl="role"
              // DropDownFields={["User Name", "Check In", "Check Out"]}
              rowData={allRoles?.filter(r => r.RoleType == "Deal")}
              renderExtraComponent={() => <></>}
              renderExtraComponentToRight={extraComponentToRight}
              isTaskFilterHide={true}
            /> : view == "Vendor" ?
              <GlobalAgGridTable
                headers={columnForZoho}
                setRowData={setAllRoles}
                cacheRowData={allCacheRoles}
                setCacheRowData={setAllCacheRoles}
                module="Roles"
                mainUrl="role"
                // DropDownFields={["User Name", "Check In", "Check Out"]}
                rowData={allRoles?.filter(r => r.RoleType == "Vendor")}
                renderExtraComponent={() => <></>}
                renderExtraComponentToRight={extraComponentToRight}
                isTaskFilterHide={true}
              /> :
              view == "Other" ?
              <GlobalAgGridTable
                headers={columnForZoho}
                setRowData={setAllRoles}
                cacheRowData={allCacheRoles}
                setCacheRowData={setAllCacheRoles}
                module="Roles"
                mainUrl="role"
                // DropDownFields={["User Name", "Check In", "Check Out"]}
                rowData={allRoles?.filter(r => r.RoleType == "Other")}
                renderExtraComponent={() => <></>}
                renderExtraComponentToRight={extraComponentToRight}
                isTaskFilterHide={true}
              />: <></>}
    </>
  }, [view,allRoles])

  return (
    <div className='Roles-Wrapper'>
      {roleModal()}
      {/* {userRoleModal()} */}
      <RolesPopupData
        openRoleModal={openRoleModal}
        onSaveCallBack={data=>{
          setprojectRoleObject({
            "RoleId": "",
            "UserId":"",
            "UserType":"",
          })
          dispatch(Socket({ trigger: "Refresh_Module", data: "Roles"}))
        }}
        setprojectRoleObject={setprojectRoleObject}
        projectRoleObject={projectRoleObject}
        onCloseRoleModal={onCloseRoleModal}
      />
      <NewCustomePopover
        width={30}
        open={errorPopConfirm}
        title={"Warning!"}
        okText={"Confirm"}
        cancelText={"Cancel"}
        onCancel={e => {
          setErrorPopConfirm(null)
        }}
        onOk={e => {
          setErrorPopConfirm(null)
        }}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <div className='Msg-Block'>
          {errorPopConfirm}
        </div>
      </NewCustomePopover>
      {/* {getToolBoxForFlag()} */}
      {/* <FolderPicker /> */}
      {/* <div className='Blueprint-Header'>
            <Row className=''>
                <Col className='d-flex align-items-center' sm={4}><FontAwesomeIcon className='logo' icon={faProjectDiagram} /><span style={{fontSize:"1rem",fontWeight:"600", marginLeft:"10px"}}>Blueprints</span></Col>
                <Col sm={4}></Col>
                <Col sm={4}></Col>
            </Row>
        </div> */}
      <div style={{width:"100%",height:"79%"}}>
        <div id="myGrid" className='ag-theme-alpine Blueprint-Body'>
          {getTableData()}
        </div>
      </div>
    </div>
  )
}

export default Roles
